module.exports = __webpack_public_path__ + "img/img3.a450a7e7.svg";